
export function searchFacet() {
    document.addEventListener('facetwp-refresh', function() {
        // Clear category facet when search is set
        if (null !== FWP.active_facet && FWP.active_facet.attr('data-name') === 'search') {
            FWP.facets['categories'] = [];
        }
    });
}